.stepItem {
  display: flex;
  align-items: center;
  height: 4rem;
  gap: 1rem;
  
  padding: 1rem 0.5rem 1rem 0px;
  margin-right: 1rem;
}

.stepItemActive {
  border-bottom: 2px solid var(--primary-enabled);

  .stepNumber {
    background-color: #ff582310;
    border-color: var(--primary-enabled);
  }
}

.stepNumber {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;

  border-radius: 1000px;
  border: 1px solid var(--static-divider-standard);

  &:is(.stepItemPassed &) {
    filter: grayscale(100%);
    opacity: 0.5;
  }

  &:is(.stepItemLocked &) {
    filter: grayscale(100%);
    opacity: 0.5;
  }
}

.stepLabel {
  &:is(.passed &) {
    color: var(--static-text-strong, #1a1a1a);
  }
}